// ** Initial State
const initialState = {
  categoryList: [],
  hgrkCategoryList: [],
  sendTemplateList: [],
  total: 1,
  params: {}
}

const categories = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_CATEGORY':
      return { ...state, 
                  categoryList: action.data.categoryList,
                  hgrkCategoryList: action.data.hgrkCategoryList,
                  sendTemplateList: action.data.sendTemplateList
              }
    case 'INSERT_CATEGORY':
      return {
        ...state,
        data: action.data
        // total: action.totalPages,
        // params: action.params
      }
    default:
      return { ...state }
  }
}
export default categories
